export const handleAddCriterrium = (setCrriteriums, criterion) => {
  setCrriteriums((prevState) => [...prevState, criterion]);
};

export const handleRemoveCriterrium = (setCrriteriums, id) => {
  setCrriteriums((prev) => prev.filter((el) => el.type_id !== id));
};
